import { Theme } from 'styling/theme'
import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme: Theme) => ({
    container: (props: { cover }) => ({
        backgroundColor: theme.colors.black,
        height: '100%',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',

        '&::before': {
            content: '""',
            position: 'absolute',
            backgroundImage: `linear-gradient(to bottom, rgba(14, 17, 23, 0.32), rgba(14, 17, 23, 0) 17%, rgba(14, 17, 23, 0) 51%, rgba(14, 17, 23, 0.8)), url(${props.cover})`,
            backgroundSize: 'cover',
            height: '100%',
            width: '100%',
            filter: 'grayscale(1) blur(8px)',
        },

        '&::after': {
            content: '""',
            position: 'absolute',
            height: '100%',
            width: '100%',
            background: 'rgba(0, 0, 0, 0.80)',
        },
    }),
    formContainer: {
        width: '100%',
        padding: '0 20px',
        zIndex: theme.zIndexLevels.one,

        '@media (min-width: 768px)': {
            width: 416,
        },
    },
    title: {
        marginBottom: 32,
        '& > h2': {
            textAlign: 'center',
            color: theme.colors.light.grey,
            fontFamily: theme.typographyPresets.fonts.monserrat.bold,
            fontStyle: 'normal',
            fontSize: 12,
        },
        '& > h1': {
            textAlign: 'center',
            fontFamily: theme.typographyPresets.fonts.monserrat.bold,
            color: theme.colors.white,
            fontSize: 20,

            '@media (min-width: 500px)': {
                fontSize: 22,
            },

            '@media (min-width: 768px)': {
                fontSize: 24,
            },
        },
    },
    input: {
        marginBottom: 24,
    },
    signInLink: {
        ...theme.typographyPresets.bodySecondaryLight,
        fontFamily: theme.typographyPresets.fonts.notoSans.regular,
        cursor: 'pointer',
        textDecoration: 'underline',
        border: 0,
        background: 0,
        color: theme.colors.white,
    },
    paragraph: {
        ...theme.typographyPresets.bodyTertiary,
        color: theme.colors.white,
    },
    signUpButton: {
        marginBottom: 32,
    },
    submitBtn: {
        fontFamily: theme.typographyPresets.fonts.monserrat.bold,
        color: theme.colors.dark.dark1,
        width: '100%',
        paddingTop: 14,
        paddingBottom: 14,
        backgroundColor: theme.colors.white,
        borderRadius: 12,
        transition: 'background .2s ease-in-out',

        '&:hover': {
            backgroundColor: '#d2d4d7',
        },
    },
    error: {
        ...theme.typographyPresets.labelPrimary,
        display: 'flex',
        alignItems: 'center',
        color: theme.colors.brand.pink,
        margin: '10px 2px',
    },
    errorIcon: {
        color: theme.colors.brand.pink,
        marginRight: 8,
    },
}))
